<div class="overlay" *ngIf="isLoading">
  <div class="spinner-chasing-dots">
    <div class="dot1"></div>
    <div class="dot2"></div>
  </div>
</div>
